import { SignInPage } from '../pages/signin';

import { HomePage } from '../pages/home';
import AccountPage from '../pages/account/AccountPage';
import { ActivationPage } from '../pages/activation/Activation';
import ExepensePage from '../pages/exepense/ExepensePage';
import DefaultCategoryPage from '../pages/default-category/DefaultCategoryPage';
import { ReportPage } from '../pages/report/ReportPage';
import { CategoryPage } from '../pages/category';
import SubscriptionPage from '../pages/subscription/SubscriptionPage';
import AdsHistoryPage from '../pages/ads/AdsHistoryPage';

const publicRoutes = [
    {
        path: '/login',
        element: SignInPage
    }
]

const priveRoutes = [
    {
        path: '/',
        element: HomePage
    },
    {
        path: '/iap',
        element: SubscriptionPage
    },
     {
        path: '/ads',
        element: AdsHistoryPage
    },
    {
        path: '/activation',
        element: ActivationPage
    },
    {
        path: '/default-category',
        element: DefaultCategoryPage
    },
    {
        path: '/category',
        element: CategoryPage
    },
    {
        path: '/exepense',
        element: ExepensePage
    },
    {
        path: '/account',
        element: AccountPage
    },
    {
        path: '/reports',
        element: ReportPage
    }
]

export { priveRoutes, publicRoutes }
